import React, { useState } from 'react';
import './Contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });

  const [formStatus, setFormStatus] = useState('');

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setFormStatus('sending');

    try {
      const response = await fetch('/api/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.error || 'Submission failed');

      console.log('✅ Contact form submitted:', data);
      setFormStatus('success');
      setFormData({ name: '', email: '', phone: '', subject: '', message: '' });
      setTimeout(() => setFormStatus(''), 5000);
    } catch (error) {
      console.error('❌ Contact form error:', error);
      setFormStatus('error');
      setTimeout(() => setFormStatus(''), 5000);
    }
  };

  return (
    <div className="contact">
      {/* Page Header */}
      <section className="page-header">
        <div className="container">
          <h1>Contact Us</h1>
          <p>GANGASEED COMPANY — We're here to help</p>
        </div>
      </section>

      {/* Contact Info & Form */}
      <section className="section">
        <div className="container">
          <div className="contact-wrapper">
            {/* Contact Information */}
            <div className="contact-info-section">
              <h2>Get In Touch</h2>
              <p className="contact-intro">
                Have questions about our seeds or need expert advice?
                Our team at Gangaseed Company is ready to assist you
                with all your agricultural needs.
              </p>

              <div className="contact-info-cards">
                <div className="info-card">
                  <div className="info-icon">📍</div>
                  <div className="info-card-body">
                    <h4>Registered Office</h4>
                    <p>
                      Plot No. 619, Nr Vihar Cross Road,<br />
                      Mahesana-Himatnagar Highway, Vihar,<br />
                      Dist.- Gandhinagar – 382810<br />
                      (Gujarat) India
                    </p>
                  </div>
                </div>

                <div className="info-card">
                  <div className="info-icon">📞</div>
                  <div className="info-card-body">
                    <h4>Customer Care</h4>
                    <p>
                      <a href="tel:+919909998802" style={{ color: 'inherit', textDecoration: 'none' }}>
                        +91 9909998802
                      </a>
                    </p>
                  </div>
                </div>

                <div className="info-card">
                  <div className="info-icon">✉️</div>
                  <div className="info-card-body">
                    <h4>Email Us</h4>
                    <p>
                      <a href="mailto:care.devkor@gmail.com" style={{ color: 'inherit', textDecoration: 'none' }}>
                        care.devkor@gmail.com
                      </a>
                    </p>
                  </div>
                </div>

                <div className="info-card">
                  <div className="info-icon">🌐</div>
                  <div className="info-card-body">
                    <h4>Website</h4>
                    <p>
                      <a href="https://www.devkorseed.com" target="_blank" rel="noopener noreferrer"
                        style={{ color: 'inherit', textDecoration: 'none' }}>
                        www.devkorseed.com
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Contact Form */}
            <div className="contact-form-section">
              <h2>Send Us a Message</h2>
              <form onSubmit={handleSubmit} className="contact-form">
                <div className="form-group">
                  <label htmlFor="name">Full Name *</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    placeholder="Enter your full name"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="email">Email Address *</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    placeholder="your.email@example.com"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="phone">Phone Number</label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    placeholder="+1 (555) 123-4567"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="subject">Subject *</label>
                  <select
                    id="subject"
                    name="subject"
                    value={formData.subject}
                    onChange={handleChange}
                    required
                  >
                    <option value="">Select a subject</option>
                    <option value="product-inquiry">Product Inquiry</option>
                    <option value="bulk-order">Bulk Order</option>
                    <option value="technical-support">Technical Support</option>
                    <option value="partnership">Partnership Opportunity</option>
                    <option value="other">Other</option>
                  </select>
                </div>

                <div className="form-group">
                  <label htmlFor="message">Message *</label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    required
                    rows="6"
                    placeholder="Tell us how we can help you..."
                  ></textarea>
                </div>

                <button 
                  type="submit" 
                  className="btn-primary submit-btn"
                  disabled={formStatus === 'sending'}
                >
                  {formStatus === 'sending' ? 'Sending...' : 'Send Message'}
                </button>

                {formStatus === 'success' && (
                  <div className="form-message success">
                    ✓ Thank you! Your message has been sent successfully. We'll get back to you soon.
                  </div>
                )}

                {formStatus === 'error' && (
                  <div className="form-message error">
                    ✗ Oops! Something went wrong. Please try again later.
                  </div>
                )}
              </form>
            </div>
          </div>
        </div>
      </section>

      {/* Map Section */}
      <section className="map-section">
        <div className="container">
          <h2 className="section-title">Find Us on Map</h2>
          <div className="map-placeholder">
            <div className="map-content">
              <div className="map-icon">📍</div>
              <p><strong>GANGASEED COMPANY</strong></p>
              <p>Plot No. 619, Nr Vihar Cross Road, Mahesana-Himatnagar Highway,</p>
              <p>Vihar, Dist.- Gandhinagar – 382810 (Gujarat) India</p>
              <p className="map-note">
                📞 +91 9909998802 &nbsp;|&nbsp; ✉️ care.devkor@gmail.com &nbsp;|&nbsp; 🌐 www.devkorseed.com
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="section faq-section" style={{backgroundColor: 'var(--white)'}}>
        <div className="container">
          <h2 className="section-title">Frequently Asked Questions</h2>
          <div className="faq-grid">
            <div className="faq-card">
              <h4>What is the minimum order quantity?</h4>
              <p>Our minimum order quantity varies by product. Please contact us for specific details.</p>
            </div>
            <div className="faq-card">
              <h4>Do you offer bulk discounts?</h4>
              <p>Yes, we offer competitive pricing for bulk orders. Contact our sales team for a quote.</p>
            </div>
            <div className="faq-card">
              <h4>What is your delivery time?</h4>
              <p>Standard delivery takes 5-7 business days. Express shipping options are available.</p>
            </div>
            <div className="faq-card">
              <h4>Do you provide technical support?</h4>
              <p>Yes, our agricultural experts provide free consultation and ongoing support to all customers.</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
